import { Suspense } from "react";
import { lazyWithReload } from "../../utils/lazyWithReload";
import type { RichTextEditorProps } from "./QuillEditor";

// Quill and its stylesheet are ~170 KB of the bundle and only needed while
// notes are being edited, so they load on first use. The service worker
// precaches the chunk, so this is instant offline too.
const QuillEditor = lazyWithReload(() => import("./QuillEditor"));

/**
 * Rich text editor used for Trip, Segment, and Interaction notes.
 */
export function RichTextEditor(props: RichTextEditorProps) {
  return (
    <Suspense fallback={<div className="rich-text-editor rich-text-editor-loading" id={props.id} />}>
      <QuillEditor {...props} />
    </Suspense>
  );
}
